import layout from './layout';
import main from './main';
import notification from './notification';

const rootReducer = { layout, main, notification };

export default rootReducer;
